import React, { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Service from '../Service/Service';
import './Services.css';

const Services = () => {
    const [services, setServices] = useState([])
    useEffect(() => {
        fetch('/services.json')
            .then(res => res.json())
            .then(data => setServices(data));
    }, [])
    return (
        <div id="services">
            <h2 className="text-primary mt-5">Our services</h2>
            {/* <div className="service-container">
                {
                    services.map(service => <Service
                        key={service.id}
                        service={service}
                    ></Service>)
                }
            </div> */}
            <Container>
                <Row>
                        {
                        services.map(service => <Service
                            key={service.id}
                            service={service}
                        ></Service>)
                        }
                </Row>
            </Container>
        </div>
    );
};

export default Services;